// CoursePurchase.jsx — نسخه نهایی لعاب‌دار و جزئیات‌دار

import React, { useState, useEffect } from "react";
import { useAuth } from "../Auth/AuthContext";
import { useNavigate } from "react-router-dom"; 
import BASE_URL from "../../config/config";
import "../../css/CoursePurchase.css";

const CoursePurchase = ({ courseId, onClose, isOpen }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const { user } = useAuth();
  const navigate = useNavigate();

  const handlePurchase = async () => {
    if (!user) {
      setError("برای خرید دوره ابتدا وارد شوید.");
      return;
    }

    setLoading(true);
    setError(null);
    setSuccessMessage("");

    // هدایت به صفحه پرداخت
    setTimeout(() => {
      navigate(`/dashboard/payment/${courseId}`);
    }, 800); // برای نمایش لحظه‌ای بارگذاری
  };

  // جلوگیری از اسکرول صفحه وقتی مدال باز است
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="purchase-modal-overlay" onClick={onClose}>
      <div 
        className="purchase-modal-content" 
        onClick={(e) => e.stopPropagation()}
      >
        <button className="purchase-modal-close" onClick={onClose}>
          &times;
        </button>
        
        <div className="purchase-modal-header">
          <h2>خرید دوره؟ 💳</h2>
        </div>

        {error && (
          <div className="purchase-error-message">
            <span className="icon">⚠️</span> {error}
          </div>
        )}

        {successMessage && (
          <div className="purchase-success-message">
            <span className="icon">✅</span> {successMessage}
          </div>
        )}

        {loading ? (
          <div className="purchase-loading">
            <div className="spinner"></div>
            <p>در حال هدایت به صفحه پرداخت...</p>
          </div>
        ) : (
          <>
            <div className="purchase-modal-body">
              <p>آیا از خرید این دوره اطمینان دارید؟</p>
              {/* <p className="small-text">این عمل غیرقابل بازگشت است.</p> */}
            </div>

            <div className="purchase-modal-footer">
              <div className="divider"></div>
              <div className="buttons-group">
                <button 
                  onClick={handlePurchase} 
                  className="purchase-confirm-btn"
                  aria-label="تأیید خرید"
                  disabled={loading}
                >
                  بله، خرید می‌کنم 🛒
                </button>
                <button 
                  onClick={onClose} 
                  className="purchase-cancel-btn"
                  aria-label="انصراف از خرید"
                >
                  انصراف ↩️
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CoursePurchase;